import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e61daf0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-content"
};
const _hoisted_2 = {
  class: "main-content flex-row"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "footer-item flex-full"
};
const _hoisted_5 = {
  class: "item flex-row"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", null, "0755-28122809"), /*#__PURE__*/_createElementVNode("div", null, "0755-27990959")], -1));
const _hoisted_7 = {
  class: "item flex-row"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "darren@Waterboger.com", -1));
const _hoisted_9 = {
  class: "item flex-row"
};
const _hoisted_10 = {
  class: "footer-content-bottom"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/"
}, "粤ICP备10208235号", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_Phone = _resolveComponent("Phone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Message = _resolveComponent("Message");
  const _component_Location = _resolveComponent("Location");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "footer-item flex-full"
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(item.title)), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (item1, index1) => {
      return _openBlock(), _createElementBlock("div", {
        class: "sub-title",
        key: index1
      }, [_createVNode(_component_router_link, {
        to: item1.link
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item1.label)), 1)]),
        _: 2
      }, 1032, ["to"])]);
    }), 128))]);
  }), 128)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
    size: "32"
  }, {
    default: _withCtx(() => [_createVNode(_component_Phone)]),
    _: 1
  }), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, {
    size: "32"
  }, {
    default: _withCtx(() => [_createVNode(_component_Message)]),
    _: 1
  }), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
    size: "32"
  }, {
    default: _withCtx(() => [_createVNode(_component_Location)]),
    _: 1
  }), _createElementVNode("div", null, _toDisplayString(_ctx.$t('location')), 1)])])]), _createElementVNode("div", _hoisted_10, [_createTextVNode(_toDisplayString(_ctx.$t('copyright')) + " ", 1), _hoisted_11])]);
}